export type AppToastSeverity = 'error' | 'warning' | 'info' | 'success';

export type AppToastPayload = {
    message: string;
    severity?: AppToastSeverity;
};

type AppToastListener = (payload: AppToastPayload) => void;

const listeners = new Set<AppToastListener>();

export const subscribeAppToast = (listener: AppToastListener) => {
    listeners.add(listener);

    return () => {
        listeners.delete(listener);
    };
};

export const pushAppToast = (payload: AppToastPayload) => {
    if (typeof window === 'undefined') {
        return;
    }

    const normalized: AppToastPayload = {
        message: payload.message,
        severity: payload.severity ?? 'error',
    };

    listeners.forEach((listener) => {
        try {
            listener(normalized);
        } catch {
            // Best effort only.
        }
    });
};
